import { jsxs as _jsxs, Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import { format, NumberKind } from "../../../helpers/numberUtils";
import { productToString } from "../../../helpers/productToString";
import List from "../../List/List";
dayjs.extend(relativeTime);
const LatestPayoutStatistics = (props) => {
    if (!props.statistics.length) {
        return null;
    }
    return (_jsx(List, Object.assign({}, props, { className: "latest-payout-statistics", label: "Latest Payouts", renderTitle: payout => (_jsxs("div", { style: { display: 'flex', gap: '12px' }, children: [format(payout.amount, { type: NumberKind.Currency }), props.showProduct ? ' - ' + productToString(payout.product) : null] })), renderDescription: payout => payout.bankName, renderActions: payout => [_jsx(_Fragment, { children: dayjs(payout.timestamp).fromNow() })] })));
};
export default LatestPayoutStatistics;
